import React, { useState, useEffect } from 'react';
import api from '../services/api';
import Layout from '../components/Layout';
import { Card, CardHeader, CardBody, Button, Table, Input } from 'reactstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';

const BusinessHourExceptions = () => {
    const [exceptions, setExceptions] = useState([]);
    const [newException, setNewException] = useState({
        date: null,
        start_time: '',
        end_time: ''
    });
    const [editingId, setEditingId] = useState(null);
    const [editedException, setEditedException] = useState({});

    useEffect(() => {
        fetchExceptions();
    }, []);

    const fetchExceptions = async () => {
        try {
            const response = await api.get('/business-hour-exceptions/');
            setExceptions(response.data);
        } catch (error) {
            console.error('Error fetching exceptions:', error);
        }
    };

    const addException = async () => {
        try {
            await api.post('/business-hour-exceptions/', {
                ...newException,
                date: newException.date ? newException.date.toISOString().split('T')[0] : null
            });
            fetchExceptions();
            setNewException({ date: null, start_time: '', end_time: '' });
        } catch (error) {
            console.error('Error adding exception:', error);
        }
    };

    const deleteException = async (id) => {
        try {
            await api.delete(`/business-hour-exceptions/${id}/`);
            fetchExceptions();
        } catch (error) {
            console.error('Error deleting exception:', error);
        }
    };

    const startEditing = (item) => {
        setEditingId(item.id);
        setEditedException({ ...item, date: new Date(item.date) });
    };

    const cancelEditing = () => {
        setEditingId(null);
        setEditedException({});
    };

    const saveEditedException = async () => {
        try {
            await api.put(`/business-hour-exceptions/${editingId}/`, {
                ...editedException,
                date: editedException.date ? editedException.date.toISOString().split('T')[0] : null
            });
            setEditingId(null);
            setEditedException({});
            fetchExceptions();
        } catch (error) {
            console.error('Error saving exception:', error);
        }
    };

    return (
        <Layout>
            <div style={{ padding: '1rem' }}>
                <Card>
                    <CardHeader tag="h3">Business Hour Exceptions</CardHeader>
                    <CardBody>
                        <Table bordered hover striped>
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Start Time</th>
                                    <th>End Time</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {exceptions.length === 0 ? (
                                    <tr>
                                        <td colSpan="4">No exceptions found</td>
                                    </tr>
                                ) : (
                                    exceptions.map((item) => (
                                        <tr key={item.id}>
                                            <td>
                                                {editingId === item.id ? (
                                                    <DatePicker
                                                        selected={editedException.date}
                                                        onChange={(date) =>
                                                            setEditedException(prev => ({ ...prev, date }))
                                                        }
                                                        className="form-control"
                                                        dateFormat="MM/dd/yyyy"
                                                    />
                                                ) : (
                                                    moment(item.date).format('MM/DD/YYYY')
                                                )}
                                            </td>
                                            <td>
                                                {editingId === item.id ? (
                                                    <Input
                                                        type="time"
                                                        value={editedException.start_time || ''}
                                                        onChange={(e) =>
                                                            setEditedException(prev => ({
                                                                ...prev,
                                                                start_time: e.target.value
                                                            }))
                                                        }
                                                    />
                                                ) : (
                                                    moment(item.start_time, 'HH:mm:ss').format('h:mm A')
                                                )}
                                            </td>
                                            <td>
                                                {editingId === item.id ? (
                                                    <Input
                                                        type="time"
                                                        value={editedException.end_time || ''}
                                                        onChange={(e) =>
                                                            setEditedException(prev => ({
                                                                ...prev,
                                                                end_time: e.target.value
                                                            }))
                                                        }
                                                    />
                                                ) : (
                                                    moment(item.end_time, 'HH:mm:ss').format('h:mm A'))}
                                            </td>
                                            <td>
                                                {editingId === item.id ? (
                                                    <>
                                                        <Button color="success" size="sm" onClick={saveEditedException}>Save</Button>{' '}
                                                        <Button color="secondary" size="sm" onClick={cancelEditing}>Cancel</Button>
                                                    </>
                                                ) : (
                                                    <>
                                                        <Button color="primary" size="sm" onClick={() => startEditing(item)}>Edit</Button>{' '}
                                                        <Button color="danger" size="sm" onClick={() => deleteException(item.id)}>Delete</Button>
                                                    </>
                                                )}
                                            </td>
                                        </tr>
                                    ))
                                )}
                                <tr>
                                    <td>
                                        <DatePicker
                                            selected={newException.date}
                                            onChange={(date) => setNewException(prev => ({ ...prev, date }))}
                                            className="form-control"
                                            dateFormat="MM/dd/yyyy"
                                            placeholderText="Select date"
                                        />
                                    </td>
                                    <td>
                                        <Input
                                            type="time"
                                            value={newException.start_time}
                                            onChange={(e) =>
                                                setNewException(prev => ({ ...prev, start_time: e.target.value }))
                                            }
                                        />
                                    </td>
                                    <td>
                                        <Input
                                            type="time"
                                            value={newException.end_time}
                                            onChange={(e) =>
                                                setNewException(prev => ({ ...prev, end_time: e.target.value }))
                                            }
                                        />
                                    </td>
                                    <td>
                                        <Button color="primary" size="sm" onClick={addException}>Add</Button>
                                    </td>
                                </tr>
                            </tbody>
                        </Table>
                    </CardBody>
                </Card>
            </div>
        </Layout>
    );
};

export default BusinessHourExceptions;
